"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustEducationRequest = void 0;
var CustEducationRequest = /** @class */ (function () {
    function CustEducationRequest() {
    }
    return CustEducationRequest;
}());
exports.CustEducationRequest = CustEducationRequest;
;
//# sourceMappingURL=custEducation.request.js.map